import * as React from "react";

export const IconPlaylistAddCheck = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_42883_32779)">
      <path
        d="M11.667 8.33333L1.66699 8.33333L1.66699 10L11.667 10V8.33333ZM11.667 5L1.66699 5L1.66699 6.66667L11.667 6.66667V5ZM1.66699 13.3333L8.33366 13.3333L8.33366 11.6667H1.66699L1.66699 13.3333ZM17.917 9.58333L19.167 10.8333L13.342 16.6667L9.58366 12.9167L10.8337 11.6667L13.342 14.1667L17.917 9.58333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_42883_32779">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
